import React from 'react';

/**
 * Numbered or bullet list with optional heading for each item (title + description).
 */
export default function PointersWithHeading({ items, numbered = true, className = '' }) {
  if (!items || !Array.isArray(items)) return null;

  return (
    <div className={`quotation-section quotation-no-break ${className}`} style={{ marginBottom: 20 }}>
      {items.map((item, i) => (
        <div key={i} style={{ marginBottom: 12 }}>
          <p style={{ fontSize: 14, fontWeight: 600, color: '#000814', margin: '0 0 4px 0' }}>
            {numbered ? `${i + 1}. ` : ''}
            {item.title || item.text || ''}
          </p>
          <p style={{ fontSize: 13, color: '#333', lineHeight: 1.5, margin: 0, paddingLeft: numbered ? 16 : 0 }}>
            {typeof item.description === 'string' ? item.description : (item.description && item.description[0]) || ''}
          </p>
        </div>
      ))}
    </div>
  );
}
